<div
  class="login-oauth-container"
  [ngStyle]="{
    'background-image': publicPageSettings && publicPageSettings.backgroungImage ? 'url(' + publicPageSettings.backgroungImage + ')' : '',
  }"
>
  <div class="modal-login mat-elevation-z24" [ngClass]="authError?.errorHtml ? 'auth-error-html' : ''">
    <div class="modal-login-form">
      @if (headerImage) {
        <img class="brand-logo" [src]="transform(headerImage)" [alt]="'accessibility_alt_brand_logo_img' | translate" />
      }
      @if (!isMultiTenant) {
        <div>
          @if (!isTwoFactorMethod) {
            <div>
              @if (!isAuthenticated) {
                <div>
                  @if (isSubmitted && authError) {
                    <div>
                      @if (!authError.errorHtml) {
                        @if (!authError.errorHtml) {
                          <app-alert
                            status="error"
                            [message]="authError.errorKey | translate"
                            [tooltip]="authError.errorMessage"
                          ></app-alert>
                        }
                        <a [routerLink]="['auth/login']" class="text-button">
                          {{ 'login_back_to_login_form' | translate }}
                        </a>
                      } @else {
                        <div class="html-auth-error">
                          <span class="error-title">{{ 'login_denied' | translate }}</span>
                          <div class="error-message" [innerHtml]="errorMessage"></div>
                          <button mat-flat-button color="primary" (click)="redirectToExternalLink(authError.errorLink)">
                            {{ authError.errorLinkText | translate }}
                          </button>
                          <a [routerLink]="['auth/login']" class="text-button">
                            {{ 'login_back_to_login_form' | translate }}
                          </a>
                        </div>
                      }
                    </div>
                  }
                </div>
              } @else {
                <app-alert status="success" [message]="'login_message_success' | translate"></app-alert>
              }
            </div>
          } @else {
            <!-- ONE TIME PIN TWO FACTOR METHOD -->
            @if (isOneTimePinTwoFactorMethod) {
              <span class="modal-title">{{ 'login_onetimepasscode_title' | translate }}</span>
              <form [formGroup]="loginOneTimePinForm" (ngSubmit)="sendOTP()" class="login-form">
                <mat-form-field>
                  <mat-label>{{ 'login_placeholder_otp' | translate }}</mat-label>
                  <input matInput type="text" formControlName="otp" autocomplete="one-time-code" autofocus />
                  @if (isSubmitted && otpFormControls.otp.errors) {
                    <mat-error>
                      {{ 'login_error_required_otp' | translate }}
                    </mat-error>
                  }
                </mat-form-field>
                @if (!isLoading) {
                  <div class="login-btn">
                    <button mat-flat-button color="primary" [disabled]="isSubmitted && isAuthenticated">
                      {{ 'login_otp_button' | translate }}
                    </button>
                  </div>
                }
                @if (isLoading) {
                  <div class="login-spinner-container">
                    <mat-spinner diameter="50"></mat-spinner>
                  </div>
                }
                @if (isSubmitted && authError) {
                  <div>
                    <app-alert status="error" [message]="authError.errorKey | translate" [tooltip]="authError.errorMessage"></app-alert>
                  </div>
                }
                <a [routerLink]="[]" (click)="resendOTP()" class="text-button">
                  {{ 'login_resend_otp_button' | translate }}
                </a>
                <!-- <a [routerLink]="[]" (click)="resetLoginFormsStatus()" class="text-button">
                {{ 'login_back_to_login_form' | translate }}
              </a> -->
              </form>
            }
          }
        </div>
      } @else {
        <span class="modal-title">{{ 'login_tenant_title' | translate }}</span>
        <form [formGroup]="loginMultitenantForm" (ngSubmit)="selectTenant()" class="login-form">
          <mat-form-field>
            <mat-select
              disableOptionCentering
              panelClass="finoffice-matselect-panel"
              panelClass="finoffice-matselect-panel"
              formControlName="tenant"
              required
            >
              @for (tenant of tenants; track tenant) {
                <mat-option class="form-field-option" [value]="tenant.key">
                  {{ tenant.value }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (!isLoading) {
            <div class="login-btn">
              <button mat-flat-button color="primary" [disabled]="isSubmitted && isAuthenticated">
                {{ 'login_tenant_button' | translate }}
              </button>
            </div>
          }
          @if (isLoading) {
            <div class="login-spinner-container">
              <mat-spinner diameter="50"></mat-spinner>
            </div>
          }
          @if (isSubmitted && authError) {
            <div>
              <app-alert status="error" [message]="authError.errorKey | translate" [tooltip]="authError.errorMessage"></app-alert>
            </div>
          }
          <!-- <a [routerLink]="[]" (click)="resetLoginFormsStatus()" class="text-button">
        {{ 'login_back_to_login_form' | translate }}
      </a> -->
        </form>
      }
    </div>
  </div>

  <div
    class="footer"
    [ngStyle]="{
      'background-color': publicPageSettings && publicPageSettings.footerBackgroundColor ? publicPageSettings.footerBackgroundColor : '',
    }"
  >
    @if (publicPageSettings) {
      <span
        [ngStyle]="{
          color: publicPageSettings && publicPageSettings.footerFontColor ? publicPageSettings.footerFontColor : '',
        }"
        >{{ publicPageSettings?.footerText }}
        <a
          [href]="publicPageSettings.footerLink"
          [ngStyle]="{
            color: publicPageSettings && publicPageSettings.footerLinkColor ? publicPageSettings.footerLinkColor : '',
          }"
          >{{ publicPageSettings?.footerLinkText }}</a
        >
        {{ publicPageSettings?.footerCopyright }}
      </span>
    }
  </div>
</div>
